import React from "react"
import { Cursor } from "../../elements"
import styled from "styled-components"

const CaseStudyCursor = ({ xValue, yValue }) => {
    return (
        <CaseStudy
            top={yValue}
            left={xValue}
            height="150"
            width="150"
            zIndex="999999"
        >
            <svg
                className="svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 175 203.35"
            >
                <title>yellow-case-sparkle</title>
                <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                        <path
                            className="cls_1"
                            d="M159.18,119.05c1-7.89,14.87-11.5,13.58-17.61C171.4,95,158.63,98.8,156,91.17c-2.76-7.88,9.76-24.07,4.81-30.59s-24,1.11-30.77-3.65-5.89-25.22-13.88-27.7c-7.71-2.39-18.62,14.89-27.12,15S69,27.32,61.31,29.93c-8,2.7-6.71,23.21-13.33,28.15S22,56,17.19,62.79s8.21,22.57,5.68,30.62C20.44,101.18,2.73,95.91.14,107c-1.85,7.9,15.07,8.39,16.42,14.3,1.8,7.9-13.51,14.84-10.83,22.47,2.76,7.88,23.23,6.33,28.18,12.86s-2,25.85,4.76,30.61,22.42-8.39,30.4-5.92c7.71,2.4,13.22,22.17,21.72,22.08s13.68-20,21.4-22.62c8-2.7,24.11,9.94,30.73,5s-.82-24.1,4-30.9,25.32-5.91,27.84-14C177.22,133.1,158.18,127,159.18,119.05Z"
                        />
                        <path
                            className="cls_2"
                            d="M67.21,102.83c-.7,3.79-3,5.91-7.86,5.91-4.38,0-6.54-1.92-7.4-4.82-.78-2.5-1.09-7.2-1.09-11.3a43.38,43.38,0,0,1,.9-10.06c.78-3.71,3.28-5.63,7.9-5.63,4.81,0,7,2.35,7.55,6.49a40.22,40.22,0,0,1,.31,5.21H62a28.64,28.64,0,0,0-.39-4.7,1.91,1.91,0,0,0-2-1.64A2.1,2.1,0,0,0,57.27,84c-.35,1.45-.43,4.19-.43,8.57a63.25,63.25,0,0,0,.43,9,2.18,2.18,0,0,0,2.27,1.95,2.07,2.07,0,0,0,2.23-2.07,40.34,40.34,0,0,0,.24-4.3h5.55A36.91,36.91,0,0,1,67.21,102.83Z"
                        />
                        <path
                            className="cls_2"
                            d="M77.27,108.38H71.56l5.2-31.22h8l4.65,31.22H83.64l-1-7.55H78.36ZM80.94,87c-.15-1.64-.27-4.73-.27-4.73s-.19,3-.35,4.73c0,.16-1.41,9.24-1.41,9.24h3.21S80.94,87.14,80.94,87Z"
                        />
                        <path
                            className="cls_2"
                            d="M101.68,108.74c-4.93,0-7.59-2-7.86-5.52a35.47,35.47,0,0,1-.08-3.72h5.44c0,1.45,0,2.55.08,2.78a2,2,0,0,0,2.26,1.72,2.15,2.15,0,0,0,2.35-2.42c0-2.63-.78-4-3.09-6.07-.39-.35-2-1.8-2.82-2.5-2.81-2.47-4.3-4.46-4.3-8.69,0-4.54,3-7.47,7.9-7.47s7.12,2.82,7.55,6.38a25.06,25.06,0,0,1,.24,3.21h-5.48a22.49,22.49,0,0,0-.15-2.55,2,2,0,0,0-2.2-2c-1.52,0-2.26.7-2.26,2.34,0,2.16,1.33,3.68,3.09,5.29.78.7,2.26,2,2.85,2.58,2.82,2.66,4.31,4.81,4.31,9C109.51,105.92,106.38,108.74,101.68,108.74Z"
                        />
                        <path
                            className="cls_2"
                            d="M115,108.38V77.16h13.78v5.36H120.7v7.59h7.51V95.2H120.7v7.9h8.13v5.28Z"
                        />
                        <path
                            className="cls_2"
                            d="M47.88,149.24c-4.93,0-7.59-2-7.86-5.52a35.35,35.35,0,0,1-.08-3.71h5.44c0,1.44,0,2.54.08,2.77a2,2,0,0,0,2.27,1.72,2.14,2.14,0,0,0,2.34-2.42c0-2.62-.78-4-3.09-6.07-.39-.35-2-1.79-2.81-2.5-2.82-2.46-4.31-4.46-4.31-8.68,0-4.54,3-7.48,7.91-7.48s7.12,2.82,7.55,6.38a27.32,27.32,0,0,1,.23,3.21H50.07a22.33,22.33,0,0,0-.15-2.54c-.16-1.26-.71-2-2.19-2s-2.27.71-2.27,2.35c0,2.15,1.33,3.68,3.09,5.28.78.7,2.27,2,2.85,2.58,2.82,2.66,4.31,4.81,4.31,9C55.71,146.42,52.58,149.24,47.88,149.24Z"
                        />
                        <path
                            className="cls_2"
                            d="M70.34,123v25.86H64.55V123H59.82v-5.36H75.15V123Z"
                        />
                        <path
                            className="cls_2"
                            d="M88.06,149.2c-4.69,0-8.09-2.39-8.09-7.43v-24.1h5.67v23.94c0,1.72.78,2.62,2.35,2.62,1.4,0,2.23-.94,2.23-2.58v-24h5.71v24.17C95.93,146.5,92.88,149.2,88.06,149.2Z"
                        />
                        <path
                            className="cls_2"
                            d="M110.68,148.89h-8.76V117.67H110c3.32,0,5.08.82,6.45,2.85,1.21,1.76,1.41,7.2,1.41,12.09,0,6.46-.2,11.23-1.41,13.3C115.41,147.67,113.89,148.89,110.68,148.89Zm1.68-16.28a77.3,77.3,0,0,0-.39-8.25,2,2,0,0,0-2.15-1.84h-2.27v21.87h2.5a1.83,1.83,0,0,0,2-1.61C112.28,141.53,112.36,134.22,112.36,132.61Z"
                        />
                        <path
                            className="cls_2"
                            d="M133.29,137.19v11.7h-5.71V137.31l-6.37-19.64H127s3.06,11.42,3.41,13c.51-1.64,3.95-13,3.95-13H140Z"
                        />
                        <path
                            className="cls_3"
                            d="M65,100.79c-.7,3.8-3,5.91-7.86,5.91-4.38,0-6.54-1.92-7.4-4.81-.78-2.51-1.09-7.2-1.09-11.31a43.29,43.29,0,0,1,.9-10c.78-3.72,3.28-5.64,7.9-5.64,4.81,0,7,2.35,7.55,6.5a39.94,39.94,0,0,1,.31,5.2H59.75a28.44,28.44,0,0,0-.39-4.69,1.92,1.92,0,0,0-2-1.65A2.1,2.1,0,0,0,55.05,82c-.35,1.45-.43,4.19-.43,8.57a63.08,63.08,0,0,0,.43,9,2.19,2.19,0,0,0,2.27,2,2.07,2.07,0,0,0,2.23-2.08,40.34,40.34,0,0,0,.24-4.3h5.55A36.78,36.78,0,0,1,65,100.79Z"
                        />
                        <path
                            className="cls_3"
                            d="M75.05,106.35H69.34l5.2-31.22h8l4.66,31.22h-5.8l-1-7.55H76.14ZM78.73,85c-.16-1.65-.28-4.74-.28-4.74s-.19,3.06-.35,4.74c0,.15-1.41,9.23-1.41,9.23H79.9S78.73,85.1,78.73,85Z"
                        />
                        <path
                            className="cls_3"
                            d="M99.46,106.7c-4.93,0-7.59-2-7.86-5.52a35.2,35.2,0,0,1-.08-3.71H97c0,1.44,0,2.54.08,2.77A2,2,0,0,0,99.3,102a2.15,2.15,0,0,0,2.35-2.43c0-2.62-.78-4-3.09-6.06-.39-.36-2-1.8-2.82-2.51-2.81-2.46-4.3-4.46-4.3-8.68,0-4.54,3-7.47,7.9-7.47s7.12,2.81,7.55,6.37a25.2,25.2,0,0,1,.24,3.21h-5.48a22.33,22.33,0,0,0-.15-2.54,2,2,0,0,0-2.2-2c-1.52,0-2.26.71-2.26,2.35,0,2.15,1.33,3.68,3.09,5.28L103,90c2.82,2.66,4.31,4.82,4.31,9C107.29,103.88,104.16,106.7,99.46,106.7Z"
                        />
                        <path
                            className="cls_3"
                            d="M112.76,106.35V75.13h13.78v5.36h-8.06v7.59H126v5.08h-7.51v7.91h8.13v5.28Z"
                        />
                        <path
                            className="cls_3"
                            d="M45.66,147.2c-4.93,0-7.59-2-7.86-5.51a35.47,35.47,0,0,1-.08-3.72h5.44c0,1.45,0,2.54.08,2.78a2,2,0,0,0,2.27,1.72A2.15,2.15,0,0,0,47.85,140c0-2.62-.78-4-3.09-6.06-.39-.35-2-1.8-2.81-2.5-2.82-2.47-4.31-4.46-4.31-8.69,0-4.54,3-7.47,7.91-7.47s7.12,2.81,7.55,6.38a27,27,0,0,1,.23,3.2H47.85a22.46,22.46,0,0,0-.15-2.54,2,2,0,0,0-2.19-2c-1.53,0-2.27.7-2.27,2.34,0,2.15,1.33,3.68,3.09,5.28.78.71,2.27,2,2.85,2.59,2.82,2.66,4.31,4.81,4.31,9C53.49,144.39,50.36,147.2,45.66,147.2Z"
                        />
                        <path
                            className="cls_3"
                            d="M68.12,121v25.86H62.33V121H57.6v-5.36H72.93V121Z"
                        />
                        <path
                            className="cls_3"
                            d="M85.85,147.16c-4.7,0-8.1-2.38-8.1-7.43v-24.1h5.67v23.94c0,1.73.78,2.63,2.35,2.63,1.41,0,2.23-.94,2.23-2.59v-24h5.71v24.18C93.71,144.46,90.66,147.16,85.85,147.16Z"
                        />
                        <path
                            className="cls_3"
                            d="M108.46,146.85H99.7V115.63h8.06c3.32,0,5.08.82,6.45,2.86,1.21,1.76,1.41,7.2,1.41,12.09,0,6.45-.2,11.22-1.41,13.3C113.19,145.64,111.67,146.85,108.46,146.85Zm1.68-16.27a77.49,77.49,0,0,0-.39-8.26,2,2,0,0,0-2.15-1.84h-2.27v21.87h2.5a1.83,1.83,0,0,0,2-1.6C110.06,139.5,110.14,132.18,110.14,130.58Z"
                        />
                        <path
                            className="cls_3"
                            d="M131.07,135.15v11.7h-5.71V135.27L119,115.63h5.82s3.06,11.42,3.41,13c.51-1.64,3.95-13,3.95-13h5.63Z"
                        />
                        <g className="sparkles">
                            <path
                                id="sparkle_1"
                                className="cls_1"
                                d="M160,28.52a18.11,18.11,0,0,1-2.83,1.16c-9.33,2.14-9.32,2.13-11,11.71a12.76,12.76,0,0,1-1,2.55l-.95,0A33.89,33.89,0,0,1,143,39.13c-.57-5.55-3.62-8.31-9.12-8.54a6.43,6.43,0,0,1-2.24-.38c-.52-.22-.88-.81-1.32-1.24.4-.35.75-.87,1.22-1,1.54-.47,3.13-.82,4.7-1.18a7.12,7.12,0,0,0,5.86-6.23c.29-1.69.54-3.39,1-5.05.13-.54.73-1,1.11-1.43.41.45,1,.84,1.2,1.37a47.06,47.06,0,0,1,1.1,4.73,6.91,6.91,0,0,0,6.34,6c2.38.34,4.72.89,7.07,1.35Z"
                            />
                            <path
                                id="sparkle_2"
                                className="cls_1"
                                d="M113.17,12.85c6.11-.15,8.35-3.89,9.34-9,1,2.21,1.52,5,3.17,6.47s4.36,1.55,7.57,2.54c-3.15,1.12-6,1.36-7.54,2.92s-1.79,4.52-2.9,7.72c-1-2.8-1.26-5.53-2.75-7.08s-4.2-1.91-6.37-2.79Z"
                            />
                            <path
                                id="sparkle_3"
                                className="cls_1"
                                d="M8.77,169.46c6.11-.15,8.35-3.89,9.34-9,1,2.21,1.52,5,3.17,6.47s4.36,1.55,7.57,2.54c-3.15,1.13-6,1.36-7.54,2.92s-1.79,4.52-2.9,7.73c-1-2.8-1.26-5.53-2.75-7.09s-4.2-1.9-6.37-2.78Z"
                            />
                            <path
                                id="sparkle_4"
                                className="cls_1"
                                d="M137.21,3.55c2.42-.06,3.31-1.54,3.7-3.55a7.84,7.84,0,0,0,1.25,2.56c.63.57,1.73.61,3,1-1.25.45-2.39.54-3,1.16s-.7,1.79-1.14,3.06c-.4-1.11-.51-2.19-1.09-2.81a7.33,7.33,0,0,0-2.52-1.1Z"
                            />
                            <path
                                id="sparkle_5"
                                className="cls_1"
                                d="M0,160.16c2.42-.06,3.3-1.54,3.7-3.55A7.74,7.74,0,0,0,5,159.17c.63.57,1.73.61,3,1-1.24.44-2.38.54-3,1.15s-.71,1.79-1.14,3.06c-.4-1.11-.51-2.19-1.1-2.8a7.29,7.29,0,0,0-2.51-1.11Z"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </CaseStudy>
    )
}

export default CaseStudyCursor

const CaseStudy = styled(Cursor)`
.cls_1 {
  fill: #eed36c;
}
.cls_2 {
  fill: #fff;
}
.cls_3 {
  fill: none;
  stroke: #0e363d;
  stroke-miterlimit: 10;
  stroke-width: 1.51px;
}

#sparkle_1,
#sparkle_2,
#sparkle_3,
#sparkle_4,
#sparkle_5 {
  opacity: 0;
  animation: appear 0.5s infinite;
}

#sparkle_1 {
  animation-delay: 0;
}

#sparkle_2 {
  animation-delay: 0.1s;
}
#sparkle_3 {
  animation-delay: 0.15s;
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
`
